import { format } from 'date-fns';

function formatDate(dateString: string) {
  return format(new Date(dateString), "dd 'de' MMM 'de' yyyy");
}

export { formatDate };
